const aaa = [

	{
		path: "chukuList",
		component: () => import("@/views/chuku/list.vue"),
		meta:{title:'出库查询'},
	},
    {
		path: "chukuAdd",
		component: () => import("@/views/chuku/add.vue"),
		meta:{title:'出库查询' },
	},
	{
		path: "chukuSee",
		component: () => import("@/views/chuku/see.vue"),
		meta:{title:'出库查询'},
	},
	
	
]
export default aaa;